import type { RedoStartedEvent, UndoStartedEvent } from "ag-grid-community";
import { atom } from "jotai";

import type { Calcs, TOptimisticCell } from "../../calcs/react";
import { store } from "../../modal";

export type TUndoRedo = TOptimisticCell & {
  pasted: boolean;
};

export const undoRedoAtom = atom<{
  undo: TUndoRedo[];
  redo: TUndoRedo[];
  time: number;
}>({
  undo: [],
  redo: [],

  // Handles an edge case where the user might paste multiple times in a row. This way we can differentiate between modifying multiple cells in 1 paste vs. multiple pastes.
  time: Date.now(),
});

function undoRedo(worker: Calcs | null, action: "undo" | "redo") {
  if (!worker) return;
  const undoRedoValue = store.get(undoRedoAtom);
  if (action === "undo") {
    for (const cell of undoRedoValue.undo) {
      worker.cellEdit(cell);
    }
  } else {
    for (const cell of undoRedoValue.redo) {
      worker.cellEdit(cell);
    }
  }
}

export const createHandleUndo = (worker: Calcs | null) => (_: UndoStartedEvent) => {
  undoRedo(worker, "undo");
};

export const createHandleRedo = (worker: Calcs | null) => (_: RedoStartedEvent) => {
  undoRedo(worker, "redo");
};
